import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import * as a from "../../../../constants/api";
import * as r from "../../../../constants/routes";
import FriendlyInfo from "../../../../components/FriendlyInfo";
import ListUsers from "../../../../components/Lists/GraphicsAdmin/GamesTableGo";
import PageHeader from "../../../../components/Headers/PageHeader";
import PageMain from "../../../../components/Main/PageMain";
import RoundButton from "../../../../components/Buttons/RoundButton";
import SessionContext from "../../../../context/sessionContext";
import Spinner from "../../../../components/Spinner";
import useFetch from "../../../../hooks/useFetch";
import pClasses from "../Users.module.scss";

export default function UserList() {
  const history = useNavigate();
  const { t } = useTranslation();
  const cSession = useContext(SessionContext);
  const [listUser, listUserIsLoading, listUserError, listUserFetch]: any =
    useFetch({
      autoInit: false,
    });
  const [listUser2, , , listUserFetch2]: any =
    useFetch({
      autoInit: false,
    });

  const namelist: any = [] as Array<any>;

  useEffect(() => {
    listUserFetch2({ url: a.API_USERS_ALL_AUDIOFOCO });
  }, [listUserFetch2]);
  if (listUser2 != null) {
    for (let i = 0; i < listUser2.length; i++) {
      namelist.push({
        nome: listUser2[i].registry,
        user_id: listUser2[i].user_id,
      });
    }
  }

  const { sub } = cSession.admin ?? {};
  useEffect(() => {
    const relat = new URL(window.location.href);
    let caixa = [] as Array<any>;
    caixa = relat.pathname.split("/").reverse();

    const bloco = a.GET_API_REPORT(caixa[0]);
    if (sub) listUserFetch({ url: bloco });
  }, [listUserFetch, sub]);

  let _content = null;
  const hasUser = listUser && listUser.length > 0;
  if (listUserIsLoading) {
    _content = <Spinner center />;
  } else if (listUserError) {
    // TODO IMG Error FETCH
  } else if (hasUser) {
    _content = (
      <>
        <ListUsers
          users={listUser}
          showUser
          showActiveStatus
          showAccess_code
          showBirthdate
        />
      </>
    );
  } else if (listUser && listUser.length === 0) {
    _content = (
      <FriendlyInfo text={t("global.The_user_hasn't_accessed_any_games_yet")}>
        <RoundButton
          small
          center
          text={t("global.back")}
          title={t("global.back")}
          onClick={() => history(r.R_A_USERS_LIST)}
        />
      </FriendlyInfo>
    );
  }

  /** NOME DO USUÁRIO */
  const relat = new URL(window.location.href);
  let caixa = [] as Array<any>;
  caixa = relat.pathname.split("/").reverse();

  const listcall = namelist.map((item: string | any) => {
    return (
      <option key={item.user_id} value={item.user_id}>
        {item.nome}
      </option>
    );
  });

  function listselect(event: React.FormEvent<HTMLSelectElement>) {
    const listid = event.currentTarget.value;
    const listname =
      event.currentTarget.options[event.currentTarget.selectedIndex].innerHTML;

    const bloco = a.GET_API_REPORT(listid);
    if (sub) listUserFetch({ url: bloco });
    const relat = new URL(window.location.href);

    let urlconcat = [] as Array<any>;
    urlconcat = relat.pathname.split("report");

    if (window.history.replaceState) {
      window.history.replaceState(
        {},
        "",
        urlconcat[0] + "report/" + listname + "/" + listid
      );
    }
  }

  return (
    <>
      <PageHeader
        title={t("global.user_report")}
        subtitle={t(
          "global.Here_you_will_find_the_individual_user_progress_report"
        )}
        username={<b>{decodeURIComponent(caixa[1])}</b>}
        allusers={
          <div className={pClasses.SelectDivSmart}>
            <select className={pClasses.SelectUserSmart} onChange={listselect}>
              <option disabled selected>
                {t("global.choose_another_user")}...
              </option>
              {listcall}
            </select>
          </div>
        }
        btnText={hasUser ? t("global.back") : null}
        btnClick={hasUser ? () => history(r.R_A_USERS_LIST) : null}
      />
      <PageMain>{_content}</PageMain>
    </>
  );
}